export default __webpack_public_path__ + "static/media/ChaltenManual20.bac3dbb8.jpg";